import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import calcReducer from './calcSlice';

export const store = configureStore({
  reducer: {
    calc: calcReducer,
  },
});

const prizeApi = 'https://api.metals.live/v1/spot'

function convertToMetricTonnes( unit:string, value:number ) {
  switch (unit) {

    case 'lb':
      return value * 2204.62
      
    case 'toz':
      return value * 35274

    default:
      return value
  }
}

async function getCountries() {
  const countryList = await fetch('js/co2factors.json')
  const jsonData = await countryList.json()
  return jsonData
}

async function getEnergyConsumption() {
  const consumptionList = await fetch('js/energyConsumption.json')
  const jsonData = await consumptionList.json()

  const precious = await (await fetch(prizeApi)).json()
  const commodities = await (await fetch(prizeApi+'/commodities')).json()
  
  const jsonWithPrizes = jsonData.map( (item:any, index:number) =>{
    if(item.apiId === '') return {...item, key:index}
    const newPrizeItem = precious.find( (metal:any) => metal[item.apiId]) || commodities.find( (metal:any) => metal[item.apiId]) || null
    if(newPrizeItem) {
      const newPrize = convertToMetricTonnes( item.unit, newPrizeItem[item.apiId])
      return {
        ...item,
        prize:newPrize,
        key:index
      }
    }
    return {...item, key:index}
  })
  return jsonWithPrizes
}

async function getCellSizes() {
  const cellList = await fetch('js/cellInfo.json')
  const jsonData = await cellList.json()
  return jsonData
}

getCountries().then( (countries) => {
  store.dispatch({ type: "calc/setCountries", payload:{countries} })
})

getEnergyConsumption().then( (energyConsumptions) => {
  store.dispatch({ type: "calc/setEnergyConsumptions", payload:{energyConsumptions} })
})

getCellSizes().then( (cellSizes) => {
  store.dispatch({ type: "calc/setCellSizes", payload:{cellSizes} })
})


export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
